module.exports = __webpack_public_path__ + "static/media/03 Generali Auto Ustandaryzowany dokument.1b5e9dd6.pdf";